import { useTranslation } from 'react-i18next';
import UploadFileIcon from "../../assets/icons/upload-file-v2.svg";
import UploadFlowChartIcon from "../../assets/icons/upload-flow-chart-v2.svg";
import UploadLinkIcon from "../../assets/icons/upload-link-v2.svg";
import SemanticIcon from "../../assets/icons/db to semantic model.svg";
import KnowledgeIcon from "../../assets/icons/Knowledge base.svg";
import questionIcon from "../../assets/icons/questionIcon.svg";
import answerIcon from "../../assets/icons/answerIcon.svg";
import paragraphIcon from "../../assets/icons/paragraphIcon.svg";
import stepsIcon from "../../assets/icons/stepsIcon.svg";
import yesorNoIcon from "../../assets/icons/yesornoIcon.svg";
import linkIcon from "../../assets/icons/linkIcon.svg";

export const TranslatedConstants = () => {
    const { t } = useTranslation('common');

    const modelsType = [
        { key: "generated", title: t('generatedModels') },
        { key: "draft", title: t('draftModels') },
    ];

    const uploadOptions = [
        {
            id: 1,
            type: t('uploadOptions.semanticModel.type'),
            icon: SemanticIcon,
            title: t('uploadOptions.semanticModel.title'),
            buttonText: t('uploadOptions.semanticModel.buttonText'),
            placeholder: t('uploadOptions.semanticModel.placeholder'),
            description: t('uploadOptions.semanticModel.description'),
        },
        {
            id: 2,
            type: t('uploadOptions.flowDiagram.type'),
            icon: KnowledgeIcon,
            title: t('uploadOptions.flowDiagram.title'),
            buttonText: t('uploadOptions.flowDiagram.buttonText'),
            placeholder: t('uploadOptions.flowDiagram.placeholder'),
            description: t('uploadOptions.flowDiagram.description'),
        },
        {
            id: 3,
            type: t('uploadOptions.uploadWebLink.type'),
            icon: UploadLinkIcon,
            title: t('uploadOptions.uploadWebLink.title'),
            buttonText: t('uploadOptions.uploadWebLink.buttonText'),
            placeholder: t('uploadOptions.uploadWebLink.placeholder'),
            description: t('uploadOptions.uploadWebLink.description'),
        },
        {
            id: 4,
            type: t('uploadOptions.uploadCSV.type'),
            title: t('uploadOptions.uploadCSV.title'),
            icon: UploadFileIcon,
            buttonText: t('uploadOptions.uploadCSV.buttonText'),
            placeholder: t('uploadOptions.uploadCSV.placeholder'),
            description: t('uploadOptions.uploadCSV.description'),
        },
    ];

    const templateData = [
        {
            id: 1,
            type: "question",
            icon: questionIcon,
            name: t('question'),
        },
        {
            id: 2,
            type: "answer",
            icon: answerIcon,
            name: t('answer'),
        },
        {
            id: 3,
            type: "paragraph",
            icon: paragraphIcon,
            name: t('paragraph'),
        },
        {
            id: 4,
            type: "steps",
            icon: stepsIcon,
            name: t('steps'),
        },
        {
            id: 5,
            type: "yesorno",
            icon: yesorNoIcon,
            name: t('yesorno'),
        },
        {
            id: 6,
            type: "link",
            icon: linkIcon,
            name: t('link'),
        },
    ];

    return { modelsType, uploadOptions, templateData };
};  